'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { Container } from '@s7/layout';
import { packSX, rem } from '@s7/styles';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const containerStyles = (theme)=>({
        padding: rem('48 28 94 28'),
        [theme.fn.between('sm1', 'md1')]: {
            padding: rem('100 32')
        },
        [theme.fn.up('md1')]: {
            padding: rem('100 0')
        }
    });
const FooterContainer = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { children, sx } = props, others = _object_without_properties_loose(props, [
        "children",
        "sx"
    ]);
    return /*#__PURE__*/ jsx(Container, _extends({
        ref: ref,
        breakpoints: {
            'md1.up': {
                fluid: false,
                size: 'md1'
            }
        },
        as: "footer",
        sx: [
            containerStyles,
            ...packSX(sx)
        ],
        fluid: true
    }, others, {
        children: children
    }));
});

export { FooterContainer };
//# sourceMappingURL=FooterContainer.js.map
